import type { DesktopNotificationQuickAction } from './desktop-quick-action';

import { postPrV2Comment, replyToPrV2Comment } from '@/data/v2/pr/fetch-pr-v2';
import { formatIssueReplyBody } from '@/lib/pr-v2/issue-comment-reply';

type ReplyAction = Extract<DesktopNotificationQuickAction, { kind: 'reply' }>;

/**
 * Posts a reply the same way the PR page does: into the review thread for a review comment, or as
 * an issue comment carrying cubic's reply footer for a conversation comment.
 */
export async function replyFromNotification(action: ReplyAction, text: string): Promise<void> {
  const number = String(action.number);

  if (action.commentType === 'review_comment') {
    await replyToPrV2Comment(action.owner, action.repo, number, action.commentId, text);
    return;
  }

  await postPrV2Comment(action.owner, action.repo, number, {
    body: formatIssueReplyBody(text, String(action.commentId)),
    commentType: 'issue_comment',
  });
}
